import axios from 'axios';

const exportMenuGroup = (url, params) => {   //console.log("yaya new"+params.record_id);
  return axios.get(url, { params });
};




export { exportMenuGroup };
